/* global window document */
/* eslint-disable no-console */

import React from 'react';
import ReactDom from 'react-dom';
import { Provider } from 'react-redux';
import ConserveParameters from './helpers/routing-conserve-parameters';
import Storage from './helpers/local-storage';
import Configuration from './config';
import ErrorHandling from './helpers/error-handling';
import { getAppConfig, handleDefaults } from './helpers/utils';
import configureStore from './store';
import { translationMessages, DEFAULT_LOCALE, getLocale } from './i18n';
import mainSaga from './main-saga';
import PortalCommunication from './portal-comms';
import ProductService from './helpers/product-service';
import RootContainer from './components/root-container';
import { LanguageProvider } from './containers/language-provider/index';
import { initialiseAnalytics } from './analytics';

ConserveParameters([
    'username',
    'password',
    'authToken',
    'env',
    'productId',
    'lang',
    'locale',
    'regionId',
    'marketRegionId',
    'countryCode',
    'userProfileId',
    'userProfileType',
    'isOneRosterActivatedSchool'
]);
Storage.namespace = 'school-roll';
export default class App {
    constructor(element, dynamicOptions) {
        // initial state based on selected product that has been passed in query string
        const initialState = ProductService.Configure();
        // Initial config
        this.store = configureStore(initialState);
        this.store.runSaga(mainSaga);
        Configuration.configure();
        // Add an interceptor to handle errors when accessing resources
        ErrorHandling.addResourceResponseErrorInterceptor();
        PortalCommunication.Configure();

        this.element = element;
        this.options = handleDefaults({}, dynamicOptions);

        // Chunked polyfill for browsers without Intl support
        if (!window.Intl) {
            (new Promise((resolve) => {
                resolve(import('intl'));
            }))
                .then(() => Promise.all([
                    import('intl/locale-data/jsonp/en.js'),
                    import('intl/locale-data/jsonp/es.js')
                ]))
                .then(() => this.renderElement(translationMessages, DEFAULT_LOCALE))
                .catch((err) => {
                    throw err;
                });
        } else {
            this.renderElement(translationMessages, DEFAULT_LOCALE);
        }
    }
    renderElement(messages, locale) {
        const config = getAppConfig();
        const baseName = config ? config.BaseName : ''; // definitely resolved
        const currentLocale = getLocale() || locale;
        initialiseAnalytics(currentLocale);

        ReactDom.render(
            <Provider store={this.store}>
                <LanguageProvider locale={currentLocale} messages={messages}>
                    <RootContainer basename={baseName} />
                </LanguageProvider>
            </Provider>,
            document.querySelector(this.element)
        );
    }
}

window.App = App;



// WEBPACK FOOTER //
// ./app/app.js